import React, { useContext, useState, useEffect } from 'react';
import useFetch from 'use-http';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import OwnerIndividual from 'src/models/tract_detail/add_ownership_revised/OwnerIndividual';

import { FormContainer, FormError, FormSection } from 'src/components/controls/forms/reactHookForm';

import { FormProvider, useForm } from 'react-hook-form';
import PersonData from 'src/components/controls/forms/composite/PersonData';
import { SelectItem } from 'src/models/common/SelectItem';
import AddressData from 'src/components/controls/forms/composite/AddressData';
import IOwner from 'src/models/IOwner';
import { DialogActionBar } from 'src/components/common/Dialog.redesign';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { CreateOwnerAction } from './CreateOwner';
import { UseFormMethods } from 'react-hook-form';
import { AnyObject } from 'react-final-form';
import PhoneNumberType from 'src/models/PhoneNumberType';
import PhoneNumberData from 'src/components/controls/forms/composite/PhoneNumberData';
import PhoneNumber from 'src/models/PhoneNumber';
import USPSCityState from 'src/models/USPSCityState';

interface ICreateIndividualProps {
    className?: string;
    style?: React.CSSProperties;
    states?: Array<SelectItem>;
    onOwnerCreated: (owner: IOwner) => void;
    actions: CreateOwnerAction[];
    phoneNumberTypes?: PhoneNumberType[];
}

const CreateIndividual: React.FC<ICreateIndividualProps> = (props) => {
    const appContext = useContext<IAppContextState>(AppContext);
    const [uspsData, setUspsData] = useState<USPSCityState>(undefined);
    const [stateValue, setStateValue] = useState<string | number>(undefined);
    const { post, response, error, get } = useFetch();
    const methods = useForm();

    // Effect to update the State and City after zipcode has been entered
    useEffect(() => {
        if (!!uspsData) {
            let uspsState: string = uspsData?.zipCode?.state;
            let uspsCity: string = uspsData?.zipCode?.city;

            updateCityState(uspsState, uspsCity);
        }
    }, [uspsData]);

    const updateCityState = (state: string, city: string) => {
        let stateId = !!props?.states ? props?.states.find((s) => s.name === state)?.id : undefined;

        if (!!stateId && !!city) {
            methods.setValue('address.state.id', stateId);
            methods.setValue('address.city', city);
            setStateValue(stateId);
        }
    };

    const getCityState = async (zipCode: string) => {
        const result = await get(`v1.0/usps/${zipCode}/local-source`);

        if (response.ok) {
            setUspsData(result);
        }
    };

    const onSubmit = async (data: AnyObject) => {
        let phoneNumberChanges: string = 'phoneNumberChanges';
        let phoneNumberAdds: string = 'phoneNumberAdds';
        let phoneNumberUpdates: string = 'phoneNumberUpdates';

        if (!!data[phoneNumberChanges]) {
            let updates: PhoneNumber[] = data[phoneNumberChanges][phoneNumberAdds];
            data[phoneNumberChanges][phoneNumberUpdates] = updates;
        }

        console.log('this is the data for the individual owner, ', data as OwnerIndividual);

        const result = await post(
            `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/owners/individual`,
            data as OwnerIndividual
        );

        if (response.ok && !isNaN(result)) {
            data.id = parseInt(result, 10);
            data.ownerType = 'Individual';
            props.onOwnerCreated(data as IOwner);
        }
    };

    const actions = (formMethods: UseFormMethods) => {
        const { isDirty, isSubmitting, isSubmitted, isValid } = methods.formState;

        if (props.actions && props.actions.length > 0) {
            return props.actions.map((a: CreateOwnerAction) => {
                if (a.isSave) {
                    return (
                        <Button
                            key={a.id}
                            disabled={isSubmitting || (isSubmitted && !isValid) || !isDirty}
                            intent={a.intent}
                            text={a.text}
                            onClick={() => formMethods.handleSubmit(onSubmit)()}
                        />
                    );
                } else {
                    return <Button key={a.id} intent={a.intent} text={a.text} onClick={a.action} />;
                }
            });
        }
        return <></>;
    };

    console.log(methods.errors);

    return (
        <>
            <FormError error={error} message="Unexpected error while saving owner." />
            <div className={props.className} style={props.style}>
                <FormProvider {...methods}>
                    <form onSubmit={methods.handleSubmit(onSubmit)}>
                        <FormContainer>
                            <FormSection title="Individual Details">
                                <PersonData required={true} includeFields={['AKA', 'MaritalStatus']} />
                            </FormSection>
                            <FormSection title="Spouse Details">
                                <PersonData namePrefix="spouse" labelPrefix="Spouse" includeFields={['AKA']} />
                            </FormSection>
                            <FormSection title="Address">
                                <AddressData namePrefix="address." states={props.states} getCityState={getCityState} stateValue={stateValue} />
                            </FormSection>
                            <FormSection title="Phone Number">
                                <PhoneNumberData phoneTypes={props?.phoneNumberTypes} />
                            </FormSection>
                        </FormContainer>
                    </form>
                </FormProvider>
            </div>
            <DialogActionBar>{actions(methods)}</DialogActionBar>
        </>
    );
};

export default CreateIndividual;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/createOwner/CreateIndividual.tsx